<template>
  <div class="header-container">
    <div class="logo-container">
      <router-link :to="{ name: 'dash' }">
        <img class="logo" src="@/assets/amt-logo-white-h32.png" alt="AMT Information Management System">
      </router-link>
    </div>
    <div class="header-menu-container">
      <p class="m0">{{ name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FixedHeader",
  computed: {
    name() {
      return this.$store.getters.userFullname
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  background-color: $brand-blue;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 $base-padding;
}

.logo {
  height: 28px;
}

.header-menu-container {
  color: $font-white;
}
</style>
